// Runtime-config lookup disabled — now sourcing config solely from build-time .env (process.env)
// import { returnConfigVariable } from "./runtimeConfig";

export const accountTypes = {
  swiftSavings: "swift savings",
  regularSavings: "regular savings",
  jointSavings: "joint savings",
  domiciliarySavings: "domiciliary savings",
  minorSavings: "minor savings",
  current: "current",
  jointCurrent: "joint current",
  domiciliaryCurrent: "domiciliary current",
};

export const accountOpeningSteps = {
  updateDetail: "update-detail",
  documentUpload: "document-upload",
  accountOpeningSuccess: "account-opening-success",
  addReference: "add-reference",
};

export const links = {
  termsAndConditionsPDF: "../assets/pdf/tc.pdf",
};

export const currencyCodes = {
  GBP: "826",
  USD: "840",
  EUR: "978",
  NGN: "566",
};

export const idValidation = [
  {
    id: 1,
    name: "pvc",
    length: 19,
  },
  {
    id: 2,
    name: "international_Passport",
    length: 9,
  },
  {
    id: 3,
    name: "nin",
    length: 11,
  },
  {
    id: 4,
    name: "drivers_license",
    length: 11,
  },
];

export const glCodes = {
  SWIFT_SAVINGS: "210805",
  REGULAR_SAVINGS: "210802",
  MINOR_SAVINGS: "210806",
  DOMICILIARY_SAVINGS: "210802",
  CURRENT: "210155",
  DOMICILIARY_CURRENT: "210155",
};

export const MAX_FILE_UPLOAD_SIZE_FIGURE = 2000;

export const MAX_FILE_UPLOAD_SIZE_TEXT = "2mb";

// Runtime-config version (disabled — kept for future revert):
// export const encryptionKeys = Object.freeze({
//   PassPhrase: returnConfigVariable("REACT_APP_PASSPHRASE"),
//   SaltValue: returnConfigVariable("REACT_APP_SALT_VALUE"),
//   InitialVector: returnConfigVariable("REACT_APP_INITIAL_VECTOR"),
//   PasswordIterations: returnConfigVariable("REACT_APP_PASSWORD_ITERATIONS"),
//   BlockSize: returnConfigVariable("REACT_APP_BLOCK_SIZE"),
// });
//
// export const apiUrl = returnConfigVariable("REACT_APP_API_URL");
//
// export const BASE_URL = returnConfigVariable("REACT_APP_BASE_URL");
//
// if (window.RUNTIME_CONFIG) {
//   delete window.RUNTIME_CONFIG;
// }

// .env-only version (active):
export const encryptionKeys = Object.freeze({
  PassPhrase: process.env.REACT_APP_PASSPHRASE ?? "",
  SaltValue: process.env.REACT_APP_SALT_VALUE ?? "",
  InitialVector: process.env.REACT_APP_INITIAL_VECTOR ?? "",
  PasswordIterations: process.env.REACT_APP_PASSWORD_ITERATIONS ?? "",
  BlockSize: process.env.REACT_APP_BLOCK_SIZE ?? "",
});

export const apiUrl = process.env.REACT_APP_API_URL ?? "";

export const BASE_URL = process.env.REACT_APP_BASE_URL ?? "";

export const decryptKey = 'dope encryption'
